// Singleton to manage notifications from non-React code
class NotificationManager {
  constructor() {
    this.showNotification = null;
  }

  // Called by NotificationContext to register the showNotification function
  initialize(showNotification) {
    this.showNotification = showNotification;
  }

  // Method to display notifications from anywhere in the code
  notify(message) {
    if (this.showNotification) {
      this.showNotification(message);
    } else {
      console.warn('NotificationManager not initialized');
    }
  }
}

export default new NotificationManager();